
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Auth"
import API1 from "../Services/Inventory"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import IngredientList from "./index";
import CenterModal from '../Components/CenterModal'
import APISS from '../Services/Location';
import Select from "react-select";

const AddIngredient = () => {
  const [isEditing, setIsEditing] = useState(false);

  const [name, setName] = useState("");
  const [measurementUnit, setMeasurementUnit] = useState("");
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [openingStock, setOpeningStock] = useState("");

  const [highlight, setHighlight] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedCenter, setSelectedCenter] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locationId, setLocationId] = useState([""]);
  const [location, setLocation] = useState([])
  useEffect(() => {
    bindMeasurementUnit();
    bindLocation();
    // bindInventoryList();
  }, [])


  const bindLocation = async () => {
    try {
      const response = await APISS.getLocationList({
        is_active: 1,
        limit: 0,
      });
      setLocation(response?.data?.data || []);
      // setLocation1(response?.data?.data || [])
    } catch (error) {
      //setError("Failed to fetch locations.");
      console.error(error);
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
    }
  };


  const validateFields = () => {
    const errors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!name?.trim()) {
      errors.name = "Name is required";
    } else if (!nameRegex.test(name)) {
      errors.name = "Name can only contain letters";
    }
    if (!measurementUnit.trim()) {
      errors.measurementUnit = "Measurement Unit is required";
    }
    // const stockRegex = /^[0-9]+$/;
    // if (!openingStock.trim()) {
    //   errors.openingStock = "Opening Stock is required";
    // } else if (!stockRegex.test(openingStock)) {
    //   errors.openingStock = "Opening Stock must be a numeric value";
    // }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value?.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }
    switch (fieldName) {
      case "name":
        setName(value);
        break;
      case "measurementUnit":
        setMeasurementUnit(value);
        break;
      case "openingStock":
        setOpeningStock(value);
        break;
      default:
        break;
    }
  };

  const bindMeasurementUnit = async (type = null) => {
    let payload = {
      is_active: 1
    }
    if (type != null) {
      payload = {
        is_active: 1,
        type
      }
    }
    const response = await API.bindMeasurementUnit(payload)
    setMeasurementUnits(response.data.data.rows)
  }

  const handleSubmit = async () => {
    if (!validateFields()) return;
    const payload = {
      name: name,
      unit: parseInt(measurementUnit),
      // qty: openingStock,
      // sale_product_id: 0,
      //  location_id: selectedLocation,
      // is_multiple: 0
    };
    // console.log('payload', payload)
    //return
    try {
      const response = await API1.Create_inventory(payload);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message || "Bad Request");
      }
      else if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      else {
        toast.error("An unexpected error occurred");
      }
    }
  };

  const handleCancel = () => {
    setTimeout(() => window.location.reload());
  }
  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };
  const locationOptions = location.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <div>
      <div className="col-12 grid-margin stretch-card">
        <div className="card">
          <div
            className={`card ${highlight ? "highlight" : ""}`}
            style={{
              backgroundColor: highlight ? "#fff" : "white",
              transition: "background-color 0.3s ease",
            }}
          >
            <div className="card-body">
              <h4 className="card-title">Add Ingredient</h4>
              <div>
                <div className="row mb-3">

                  {/* <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="ddSalesType" className="form-label">
                        <b>Center</b>
                      </label>
                      <Select
                        id="ddSalesType"
                        options={locationOptions}
                        placeholder="Select Center"
                        isSearchable={true}
                        value={locationOptions.find(
                          (opt) => opt.value === selectedLocation
                        )}
                        onChange={(selectedOption) =>
                          setSelectedLocation(selectedOption?.value)
                        }
                      />

                    </div>

                  </div> */}

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="txtname" className="form-label">
                        Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        id="txtname"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => handleFieldChange(e, "name")}
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="ddMeasurementUnit" className="form-label">
                        Measurement Unit <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-select ${errors.measurementUnit ? "is-invalid" : ""}`}
                        id="ddMeasurementUnit"
                        value={measurementUnit}
                        onChange={(e) => handleFieldChange(e, "measurementUnit")}
                      >
                        <option value="">Select Unit </option>
                        {measurementUnits.map((unit) => (
                          <option key={unit.id} value={unit.id}>
                            {unit.name}
                          </option>
                        ))}
                      </select>
                      {errors.measurementUnit && (
                        <div className="invalid-feedback">{errors.measurementUnit}</div>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="txtstock" className="form-label">
                        Opening Stock <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.openingStock ? "is-invalid" : ""}`}
                        id="txtstock"
                        placeholder="Stock"
                        value={openingStock}
                        onChange={(e) => handleFieldChange(e, "openingStock")}
                      />
                      {errors.openingStock && (
                        <div className="invalid-feedback">{errors.openingStock}</div>
                      )}
                    </div>
                  </div> */}

                </div>
                <div className="mt-3">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary me-2"
                    style={{ display: isEditing ? "none" : "inline-block" }}
                  >
                    Submit
                  </button>


                  <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IngredientList />
      <ToastContainer />
    </div>

  );
};

export default AddIngredient;
